import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function myCompletedJobsReducer(state = initialState.myCompletedJobs, action) {
  switch (action.type) {
    case types.LOAD_MY_COMPLETED_JOBS_SUCCESS:
      return action.myCompletedJobs;

    default:
      return state;
  }
}
